import React, { useState } from "react";
import { getRuta } from "../../../../helpers/Helpers";
import {
  BotonGenerar,
  FormularioSelector,
  SelectorOpciones,
} from "../../../../components/reportes/selector";

const ESTADOS_CLIENTE = [
  { valor: 0, nombre: "ACTIVOS" },
  { valor: 1, nombre: "INACTIVOS" },
  { valor: 2, nombre: "TODOS..." },
];

// La tabla se ordena con un clic en el encabezado. La ruta conserva su último segmento
// para no romper enlaces anteriores: 0 = por nombre.
const ORDEN_INICIAL = 0;

const SelectorClientsGestor = () => {
  const [selectedStatus, setSelectedStatus] = useState(2);

  let ruta = getRuta();

  const verReport = () => {
    var params = `${selectedStatus}/${ORDEN_INICIAL}`;
    window.open(`${ruta}/r-clientsgestor/${params}`);
  };

  return (
    <FormularioSelector>
      <SelectorOpciones
        label="Estado del Cliente"
        value={selectedStatus}
        onChange={setSelectedStatus}
        opciones={ESTADOS_CLIENTE}
      />

      <BotonGenerar onClick={verReport} />
    </FormularioSelector>
  );
};

export default SelectorClientsGestor;
